import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{staticClass:"home text-xs-center",attrs:{"fluid":"","grid-list-sm":""}},[_c(VLayout,{attrs:{"align-center":"","justify-center":"","row":"","pa-5":"","mb-8":""}},[_c(VFlex,{attrs:{"xs12":"","sm10":"","md6":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }